import { ReactNode } from "react";
// MUI
import { Divider } from "@mui/material";

// Components
import CollapsibleCard from "@Layouts/components/Cards/CollapsibleCard";
import DetailedColumnTable from "@DataPages/components/Inventory/Tables/DetailedColumnTable";

// Icons
import DropIcon from "@/assets/icons/dataPages/inventory/drop.svg";
import TagPrice from "@/assets/icons/dataPages/inventory/tag-price.svg";
import Settings from "@/assets/icons/dataPages/inventory/settings.svg";
import Floor from "@/assets/icons/dataPages/inventory/floor.svg";
import DealerIcon from "@/assets/icons/dataPages/inventory/dealer.svg";
import OptionPackage from "@/assets/icons/dataPages/inventory/package.svg";
import InformationIcon from "@/assets/icons/dataPages/inventory/orderInfo.svg";
import SimpleOptionIcon from "@/assets/icons/dataPages/inventory/simple-options.svg";
import LocationIcon from "@/assets/icons/dataPages/inventory/location.svg";
import VehicleIcon from "@/assets/icons/dataPages/inventory/vehicle.svg";

// Types
import { Inventory, IVehicleDMSProperty } from "@/DataPages/types/inventory/models/inventory";

type VehicleColumnDetailProps = {
	data: Inventory | undefined;
	inventoryId: string;
	gpsInconsistency?: boolean;
	expandedRows?: boolean;
	customGPSDeviceSection?: ReactNode;
};

const iconMap: { [key: string]: string } = {
	color: DropIcon,
	price: TagPrice,
	settings: Settings,
	floor: Floor,
	option: SimpleOptionIcon,
	package: OptionPackage,
	order: InformationIcon,
	dealer: DealerIcon,
	vehicle: VehicleIcon,
	location: LocationIcon,
};

/********************************************* HELPERS ************************************************/
const getIcon = (iconName: string | undefined) => {
	return iconMap[iconName ?? ""] || InformationIcon;
};

const deviceInfoColumnIndex = 1;
export default function vehicleColumnDetail(props: Readonly<VehicleColumnDetailProps>): JSX.Element[] {
	return (
		props.data?.properties?.map((item: IVehicleDMSProperty, index) => {
			return (
				<CollapsibleCard
					key={item.displayName}
					customTitle={item.displayName}
					customTitleClasses="!font-montserrat !text-[14px] !ml-[0px]"
					expanded
					addClassName={`!w-[250px]`}
					innerClass={"!p-0"}
					icon={<img src={getIcon(item.icon)} alt="icon" className="m-auto h-[15px] w-[15px]" />}
				>
					<DetailedColumnTable expandedRows={props.expandedRows ?? false} rows={JSON.parse(item.value as string)} />
					{index === deviceInfoColumnIndex && (
						<>
							<Divider className="!mt-6 !mb-5" />
							{props?.customGPSDeviceSection && props.customGPSDeviceSection}
						</>
					)}
				</CollapsibleCard>
			);
		}) ?? []
	);
}
